import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'

const spin = keyframes`
  to { transform: rotate(360deg)};
`

export const Loader = styled('div')`
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-left-color: rgb(0, 174, 239);
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: ${spin} 1.2s linear infinite;
`

export const Container = styled('div')(
  (props) => `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: ${props.minHeight || '80vh'};
`,
)
